import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Button,
  Input,
  FormControl,
  FormLabel,
  HStack,
  Stack,
  Image,
  useToast,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useRef } from 'react';
import { useCtx } from '../../context/AppContext';

export default function AddProductDrawer() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [image, setImage] = useState(null);
  const [title, setTitle] = useState('');
  const [color, setColor] = useState('');
  const [price, setPrice] = useState('');
  const [size, setSize] = useState('');
  const btnRef = useRef();
  const formRef = useRef();
  const toast = useToast();
  const { addProductToList } = useCtx();

  const handleInput = e => {
    let value = e.target.value;
    switch (e.target.name) {
      case 'color':
        setColor(value);
        break;
      case 'price':
        setPrice(value);
        break;
      case 'title':
        setTitle(value);
        break;
      case 'size':
        setSize(value);
        break;
      case 'image':
        value = e.target.files[0];
        if (value) {
          setImage(URL.createObjectURL(value));
        }
        break;
      default:
        break;
    }
  };

  const save = () => {
    let id = new Date().getTime();
    if (
      color.trim() === '' ||
      title.trim() === '' ||
      price.trim() === '' ||
      size.trim() === '' ||
      !image
    ) {
      toast({
        status: 'error',
        title: 'Fill all fields please',
      });
    } else {
      let data = { color, title, img: image, id, size, price };
      addProductToList(data);
      toast({
        status: 'success',
        title: 'added successfully',
      });
      onClose();
      setColor('');
      setPrice('');
      setSize('');
      setTitle('');
      setImage(null);
    }
  };

  return (
    <>
      <Button ref={btnRef} colorScheme="teal" onClick={onOpen}>
        Add Product
      </Button>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Add product</DrawerHeader>

          <DrawerBody>
            <Stack spacing="5" as="form" ref={formRef} id="addpdform">
              <FormControl>
                <FormLabel>Product Title</FormLabel>
                <Input
                  value={title}
                  onChange={handleInput}
                  name="title"
                  type="text"
                  placeholder="title"
                />
              </FormControl>
              <HStack>
                <FormControl>
                  <FormLabel>Color</FormLabel>
                  <Input
                    value={color}
                    onChange={handleInput}
                    name="color"
                    type="text"
                    placeholder="eg, red"
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Size</FormLabel>
                  <Input
                    value={size}
                    onChange={handleInput}
                    name="size"
                    type="text"
                    placeholder="eg, 6.9 in"
                  />
                </FormControl>
              </HStack>
              <FormControl>
                <FormLabel>Price ($)</FormLabel>
                <Input
                  value={price}
                  onChange={handleInput}
                  name="price"
                  type="number"
                  placeholder="price"
                />
              </FormControl>
              <FormControl>
                <FormLabel>Image</FormLabel>

                <Input
                  type="file"
                  accept="image/*"
                  name="image"
                  onChange={handleInput}
                />
                <Image src={image} w="100px0" h="100px" objectFit="contain" />
              </FormControl>
            </Stack>
          </DrawerBody>

          <DrawerFooter>
            <Button variant="outline" mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button onClick={save} colorScheme="blue">
              Save
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}
